// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__25169","log":"ModalInventoryLogs_log__1rki9","date":"ModalInventoryLogs_date__2yUmD","userName":"ModalInventoryLogs_userName__1O8km"};